class Cache {

  constructor(defaultValue = null, data) {

    this.defaultValue = defaultValue;
    this.data = data;

  }

  reset() {

    this.data = this.defaultValue;

  }

  isAvailable() {

    return this.data !== this.defaultValue;

  }

  getData() {

    return this.data;

  }

  setData(data) {

    this.data = data;

  }

}

export default Cache;